// Sort.jsx
import React, { useEffect, useMemo, useState, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { setPerPage } from '../../reducers/product.reducer'
import { setPerPageSearchQuery, setSortSearchQuery } from '../../reducers/components/searchQuery'
import { getProducts } from '../../actions'
import { getProductsBySlug } from '../../actions/product.action'
import SelectComponent from '../SelectComponent'
import SortPanel from './SortPanel'

export const Sort = ({
    additionalData,
    sortType,
    noneSelectUpdatedPictures,
    setUpdatedPictures,
    valueTabsSort,
    dispatchAction,
    updatedPictures,
    setPageNumber,
    setPageSize,
    productSort,
    search,
    sortSearch,
    pageNumber,
    sortItems,
    setSortReducer,
    pageSize,
    typeSort,
    get,
    embedded = false,
}) => {
    const dispatch = useDispatch()
    const [sort, setSort] = useState(sortItems ? sortItems : 'createdAtMinus')
    const { slug } = useParams()

    const lastFetchRef = useRef("")

    const additionalStatusFilter = additionalData?.statusFilter
    const additionalSearchMainName = additionalData?.searchMainName
    const additionalValueTabsSort = additionalData?.valueTabsSort
    const additionalVisibilityFilter = additionalData?.visibilityFilter || 'all'

    const runUpdater = (handler, value) => {
        if (typeof handler !== 'function') return
        const result = handler(value)
        if (result && typeof result === 'function') {
            dispatch(result)
            return
        }
        if (result && typeof result === 'object' && result.type) {
            dispatch(result)
        }
    }

    const selectItem = useMemo(() => {
        if (typeSort === 'user') {
            return [
                { value: 'role', text: 'Роль A–Z' },
                { value: 'roleMinus', text: 'Роль Z–A' },
                { value: 'email', text: 'Email A–Z' },
                { value: 'emailMinus', text: 'Email Z–A' },
                { value: 'createdAtMinus', text: 'Новые дата регистрации' },
                { value: 'createdAt', text: 'Старые дата регистрации' },
                { value: 'updatedAtMinus', text: 'Последние изменения' },
                { value: 'updatedAt', text: 'Старые изменения' },
            ]
        }

        if (typeSort === 'promo') {
            return [
                { value: 'createdAtMinus', text: 'Сначала новые' },
                { value: 'createdAt', text: 'Сначала старые' },
                { value: 'amountMinus', text: 'Номинал по убыванию' },
                { value: 'amount', text: 'Номинал по возрастанию' },
                { value: 'code', text: 'Код A–Z' },
                { value: 'codeMinus', text: 'Код Z–A' },
                { value: 'usedMinus', text: 'Больше использований' },
                { value: 'used', text: 'Меньше использований' },
            ]
        }

        if (typeSort === 'transaction') {
            return [
                { value: 'createdAtMinus', text: 'Сначала новые' },
                { value: 'createdAt', text: 'Сначала старые' },
                { value: 'amountMinus', text: 'Сумма по убыванию' },
                { value: 'amount', text: 'Сумма по возрастанию' },
                { value: 'type', text: 'Тип A–Z' },
                { value: 'typeMinus', text: 'Тип Z–A' },
            ]
        }

        return [
            { value: 'name', text: 'По названию от А-Я' },
            { value: 'nameMinus', text: 'По названию от Я-А' },
            { value: !productSort ? 'email' : 'price', text: !productSort ? 'Email A-Z' : 'По цене от дешевого к дорогому' },
            { value: !productSort ? 'emailMinus' : 'priceMinus', text: !productSort ? 'Email Z-A' : 'По цене от дорогого к дешевому' },
            { value: 'updatedAtMinus', text: 'Самые последние изменения' },
            { value: 'updatedAt', text: 'Самые старые изменения' },
            { value: 'createdAtMinus', text: 'Самые новые' },
            { value: 'createdAt', text: 'Самые старые' },
            productSort && { value: 'byPopularityUp', text: 'Популярность вверх' },
            productSort && { value: 'byPopularityDown', text: 'Популярность вниз' },
        ].filter(Boolean)
    }, [typeSort, productSort])

    const updatedPicturesArray = [
        { text: 'Все', value: 'all' },
        { text: 'Только Готовые', value: 'updatedPictures' },
        { text: 'Без обновленных', value: 'picturesNotUpdated' },
    ]

    const handleChange = (event) => {
        const next = event.target.value
        if (dispatchAction) {
            dispatch(setSortSearchQuery(next))
        } else {
            setSort(next)
        }
        runUpdater(setPageNumber, 0)
        runUpdater(setSortReducer, next)
    }

    const handleChangeUpdatedPictures = (event) => {
        if (typeof setUpdatedPictures === 'function') {
            setUpdatedPictures(event.target.value)
        }
    }

    const handlePaginateChange = (event) => {
        const val = Number(event.target.value)
        if (dispatchAction) {
            dispatch(setPerPageSearchQuery(val))
            runUpdater(setPageNumber, 0)
        } else {
            runUpdater(setPageSize, val)
            runUpdater(setPageNumber, 0)
        }
    }

    // ИСПРАВЛЕНИЕ: Вынес обновление Redux стора продуктов в изолированный useEffect.
    // Теперь изменение pageNumber при пагинации не дергает лишние экшены.
    useEffect(() => {
        if (pageSize) {
            dispatch(setPerPage(pageSize))
        }
    }, [dispatch, pageSize])

    useEffect(() => {
        const currentFetchSignature = JSON.stringify({
            sort,
            pageNumber,
            pageSize,
            updatedPictures,
            typeSort,
            slug,
            visibilityFilter: additionalVisibilityFilter,
            statusFilter: additionalStatusFilter,
            searchMainName: additionalSearchMainName,
            valueTabsSort: additionalValueTabsSort || valueTabsSort,
        });
        if (lastFetchRef.current === currentFetchSignature) return;

        lastFetchRef.current = currentFetchSignature;

        if (productSort) {
            if (additionalSearchMainName && typeof search === 'function') {
                dispatch(search(
                    additionalSearchMainName,
                    sort,
                    sortSearch,
                    {
                        ...(additionalData || {}),
                        visibilityFilter: additionalVisibilityFilter,
                        pageNumber,
                        pageSize,
                        updatedPictures,
                        slug,
                    }
                ))
                return
            }

            if (slug === 'all') {
                dispatch(getProducts(
                    sort,
                    pageNumber,
                    pageSize,
                    updatedPictures,
                    additionalVisibilityFilter
                ))
            } else {
                dispatch(getProductsBySlug(
                    slug,
                    sort,
                    pageNumber,
                    pageSize,
                    updatedPictures,
                    additionalVisibilityFilter
                ))
            }
            return
        }

        if (typeSort === 'user') {
            if (typeof get === 'function') {
                dispatch(get(undefined, sort, pageNumber, pageSize))
            }
            return
        }

        if (typeSort === 'promo' || typeSort === 'transaction') {
            if (typeof get === 'function') {
                dispatch(get(sort, pageNumber, pageSize, updatedPictures, {
                    ...additionalData,
                    statusFilter: additionalStatusFilter,
                    pageNumber,
                    pageSize
                }))
            }
            return
        }

        if (sort && typeSort === 'orderSort' && typeof get === 'function') {
            dispatch(get(
                additionalSearchMainName,
                additionalValueTabsSort || valueTabsSort,
                sort
            ))
            return
        }

        if (get && sort) {
            dispatch(get(sort, pageNumber, pageSize, updatedPictures, additionalData))
        }
    }, [
        sort,
        pageNumber,
        pageSize,
        updatedPictures,
        productSort,
        typeSort,
        slug,
        search,
        sortSearch,
        additionalVisibilityFilter,
        dispatch,
        get,
        additionalStatusFilter,
        additionalSearchMainName,
        additionalValueTabsSort,
        valueTabsSort,
        additionalData
    ])

    const content = (
        <div className="sortComponent">
                {noneSelectUpdatedPictures ? null : (
                    <SelectComponent
                        title="Обновлённые фото"
                        selectItem={updatedPicturesArray}
                        value={updatedPictures}
                        handleChange={handleChangeUpdatedPictures}
                        minWidth={200}
                    />
                )}

                <SelectComponent
                    title="Сортировка"
                    selectItem={selectItem}
                    value={dispatchAction && sortItems ? sortItems : sort}
                    handleChange={handleChange}
                    minWidth={200}
                />

                <SelectComponent
                    title="Показывать"
                    selectItem={[
                        { value: 12 },
                        { value: 20 },
                        { value: 25 },
                        { value: 50 },
                        { value: 75 },
                        { value: 100 }
                    ]}
                    value={pageSize}
                    handleChange={handlePaginateChange}
                    minWidth={140}
                />
        </div>
    )

    if (embedded) {
        return content
    }

    return (
        <SortPanel>
            {content}
        </SortPanel>
    )
}
